// Mapping for frontend 'SURVEY' concept to a backend-supported test type
export const SURVEY_MAPPED_TYPE = "MENTAL_WELLBEING";

const testTypes = {
  SURVEY_MAPPED_TYPE,
};

export default testTypes;
